<script setup>
defineProps({
    name: {
        type: String,
        required: true,
        //validator: x => !!document.getElementById('svg-' + x), // FIXME: Doesn't work in test
    },
    size: {
        type: String,
        required: false,
        default: () => 'inline',
        validator: x => ['inline', 'micro', 'mini', 'xs', 'sm', 'md', 'lg'].includes(x),
    },
});
</script>

<template>
    <svg :class="['svg-icon', 'svg-icon--' + size]">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="'#svg-' + name" />
    </svg>
</template>
